import { FC } from 'react';
import { useContextSelector as useCS } from 'use-context-selector';
import { Modal } from '@mui/material';
import { CloseIcon, DeleteAccountModalIcon } from 'assets';
import { TUpdate } from 'domain/types';
import { Button, Spinner } from 'view/components';
import * as CS from 'view/modals/styled';
import {
  CreateJobPostConfigContext,
  TCreateJobPostContextState,
} from 'domain/createJobPostConfig/CreateJobPostContext';
import { createJobPostConfigSelectors } from 'domain/createJobPostConfig/selectors';
import { useDeleteJobPostById } from 'view/pages/createJobPost/hooks/useDeleteJobPostById';
import { useStateMachine } from 'little-state-machine';
import { resetForm } from 'view/pages/createJobPost/helpers/resetForm';
import { useNavigate } from 'react-router';

const CreateJobPostBackToHomeModal: FC<{
  hideCloseButton?: boolean;
  onDraftSubmitClick: any;
  endIcon: any;
  disabled: boolean;
}> = ({ hideCloseButton = false, onDraftSubmitClick, endIcon, disabled }) => {
  const navigate = useNavigate();
  const isOpenBackToHomeModal: boolean = useCS(
    CreateJobPostConfigContext,
    createJobPostConfigSelectors.isOpenBackToHomeModal
  );

  const createJobPostData: any = useCS(
    CreateJobPostConfigContext,
    createJobPostConfigSelectors.createJobPostData
  );

  const update: TUpdate<TCreateJobPostContextState> | undefined = useCS(
    CreateJobPostConfigContext,
    createJobPostConfigSelectors.update
  );

  const { actions } = useStateMachine({
    actions: { resetForm },
  });

  const { isLoading, send } = useDeleteJobPostById();

  const onClose = () => {
    if (update) update({ isOpenBackToHomeModal: false });
  };

  const onDeleteClick = () => {
    send();
  };

  return (
    <Modal
      open={isOpenBackToHomeModal}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <CS.ModalMainWrapper>
        {!hideCloseButton ? (
          <CS.CloseIconBox onClick={onClose}>
            <CloseIcon />
          </CS.CloseIconBox>
        ) : null}
        <CS.ModalMainBox>
          <CS.ModalMainImage>
            <DeleteAccountModalIcon />
          </CS.ModalMainImage>
          <CS.ModalMainHeader>
            <CS.ModalMainHeaderTitle>Proceed without changes?</CS.ModalMainHeaderTitle>
            <CS.ModalMainHeaderSubTitle>
              {
                'Please save the updates before you continue \n so you don\u0027t lose the information you\u0027ve filled in'
              }
            </CS.ModalMainHeaderSubTitle>
          </CS.ModalMainHeader>
        </CS.ModalMainBox>
        <CS.ModalMainFooter>
          <Button
            variant="outlined"
            text="Exit without saving"
            onClick={() => {
              if (createJobPostData?.editStatus === 'edit') {
                actions.resetForm();
                navigate('/candidates/my-job-posts?postStatus=active', { replace: true });
                onClose();
              } else {
                onDeleteClick();
              }
            }}
            disabled={isLoading}
            endIcon={isLoading ? <Spinner disabled={isLoading} variant="outlined" /> : null}
            style={{ width: '100%', minHeight: '50px' }}
          />
          <Button
            variant="contained"
            text="Save as Draft"
            onClick={onDraftSubmitClick}
            endIcon={endIcon}
            disabled={disabled}
          />
        </CS.ModalMainFooter>
      </CS.ModalMainWrapper>
    </Modal>
  );
};

export default CreateJobPostBackToHomeModal;
